import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Menu,
  MenuItem,
} from "@mui/material";
import { Button, Modal } from "pepsico-ds";
import { useState } from "react";
import ProductGroupsTable from "./ProductGroupsTable";
import "./productManagement.scss";

const ProductGroupsListView = ({
  productGroups,
  allProducts,
  loading,
  onViewGroup,
  onAddGroup,
  onImportFile,
  onEditGroup,
  onDeleteGroup,
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [targetGroup, setTargetGroup] = useState(null);
  const [deleteBlockedMessage, setDeleteBlockedMessage] = useState("");

  const handleAddClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleCreateGroup = () => {
    handleMenuClose();
    onAddGroup();
  };

  const handleImportFile = () => {
    handleMenuClose();
    onImportFile();
  };

  const handleDeleteGroup = (group) => {
    if (group.isLinked) {
      const links = Array.isArray(group.linkedTo)
        ? group.linkedTo
        : [group.linkedTo];
      const attachedTo = [
        ...new Set(links.map((link) => link?.attachedTo).filter(Boolean)),
      ].join(", ");

      setDeleteBlockedMessage(
        `Product group "${group.name}" is attached to ${
          attachedTo || "another item"
        } and cannot be deleted.`
      );
      return;
    }

    setTargetGroup(group);
    setDeleteModalOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteModalOpen(false);
    setTargetGroup(null);
  };

  const handleDeleteConfirm = () => {
    if (targetGroup && onDeleteGroup) {
      onDeleteGroup(targetGroup);
    }
    handleDeleteClose();
  };

  return (
    <div className="product-groups-list-view">
      <div className="product-groups-list-actions">
        <Button
          text="Add product group"
          onClick={handleAddClick}
          size="medium"
          iconTrailing="arrow_drop_down"
          className="add-product-group-dropdown-btn"
        />
        <Menu
          anchorEl={menuAnchorEl}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleCreateGroup} sx={{ minWidth: "180px" }}>
            Create single group
          </MenuItem>
          <MenuItem onClick={handleImportFile} sx={{ minWidth: "180px" }}>
            Import file
          </MenuItem>
        </Menu>
      </div>
      <ProductGroupsTable
        productGroups={productGroups}
        allProducts={allProducts}
        loading={loading}
        onViewGroup={onViewGroup}
        onEditGroup={onEditGroup}
        onDeleteGroup={handleDeleteGroup}
      />

      <Dialog
        open={deleteModalOpen}
        onClose={handleDeleteClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <h3 style={{ margin: 0 }}>Remove product group?</h3>
            </Grid>
            <Grid item>
              <CloseIcon onClick={handleDeleteClose} className="cursor-pointer" />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <p style={{ margin: 0 }}>
            Are you sure you want to remove this group? This action can&apos;t be
            undone.
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            variant="secondary"
            onClick={handleDeleteClose}
            text="Cancel"
            size="small"
          />
          <Button
            variant="primary"
            onClick={handleDeleteConfirm}
            text="Remove"
            size="small"
          />
        </DialogActions>
      </Dialog>

      <Modal
        showModal={Boolean(deleteBlockedMessage)}
        title="Cannot Delete Product Group"
        text={deleteBlockedMessage}
        onCloseModal={() => setDeleteBlockedMessage("")}
        showPrimaryButton={true}
        showSecondaryButton={false}
        primaryButtonProps={{
          size: "medium",
          text: "Cancel",
          variant: "secondary",
          onClick: () => setDeleteBlockedMessage(""),
        }}
        showTertiaryButton={false}
        showLink={false}
      />
    </div>
  );
};

export default ProductGroupsListView;
